import { render, staticRenderFns } from "./ProcessList.vue?vue&type=template&id=f5ba111a&scoped=true"
import script from "./ProcessList.vue?vue&type=script&lang=js"
export * from "./ProcessList.vue?vue&type=script&lang=js"
import style0 from "./ProcessList.vue?vue&type=style&index=0&id=f5ba111a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ba111a",
  null
  
)

export default component.exports